import { useEffect, useState } from "react";
import styles from "./MoreBelow.module.css";

export default function MoreBelow() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timer;
    function update() {
      window.clearTimeout(timer);
      setVisible(false);
      timer = window.setTimeout(() => {
        const remaining = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
        setVisible(window.scrollY > 24 && remaining > 80);
      }, 650);
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    // Recheck when images or asynchronously loaded sections change page height.
    const observer = new ResizeObserver(update);
    observer.observe(document.body);
    update();
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      observer.disconnect();
    };
  }, []);

  return (
    <div className={`${styles.indicator} ${visible ? styles.visible : ""}`} aria-hidden="true">
      <span>Keep exploring</span>
      <svg width="18" height="22" viewBox="0 0 24 28" fill="none">
        <path d="m6 8 6 6 6-6M6 16l6 6 6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}
